const ACTIONS_COLUMN_ID = 'actions';

/** `sticky` needs separate borders: collapsed ones stay behind when a cell sticks. */
export const PINNED_TABLE_CLASS =
  'border-separate border-spacing-0 [&_th]:border-b [&_td]:border-b [&_tbody_tr:last-child>td]:border-b-0';

const START_CLASS = 'sticky start-0 z-10 border-e border-border';
const END_CLASS = 'sticky end-0 z-10 border-s border-border whitespace-nowrap';

const HEAD_CLASS = {start: START_CLASS, end: END_CLASS};
// Body cells inherit their row's background so scrolled content never shows through.
const BODY_CLASS = {start: `${START_CLASS} bg-inherit`, end: `${END_CLASS} bg-inherit`};

/** The first column pins to the start edge and a column with id `actions` to the end edge. */
export function getPinnedClassName(
  columnId: string,
  index: number,
  isHeader: boolean
): string | undefined {
  const side = columnId === ACTIONS_COLUMN_ID ? 'end' : index === 0 ? 'start' : undefined;
  return side && (isHeader ? HEAD_CLASS : BODY_CLASS)[side];
}
